export enum PasswordChangeError {
  NOT_AUTHORIZED = 'NotAuthorizedException',
  LIMIT_EXCEEDED = 'LimitExceededException',
  INVALID_PASSWORD = 'InvalidPasswordException'
}
